import {
  Activity,
  Globe,
  MapPin,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  BarChart3,
  Bell,
  Book,
  BookOpen,
  Box,
  Building2,
  Calendar,
  Check,
  CircleAlert,
  CircleCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  Mic,
  MicOff,
  PhoneOff,
  Copy,
  Clock,
  Crown,
  Download,
  Eye,
  EyeOff,
  FilePlus,
  FileSpreadsheet,
  FileText,
  Filter,
  Folder,
  Hash,
  Heart,
  House,
  Image,
  Info,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  Link,
  LineChart,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MessageCircle,
  Monitor,
  MoreHorizontal,
  Paperclip,
  Palette,
  PawPrint,
  Pencil,
  Phone,
  PieChart,
  Play,
  Plus,
  Printer,
  RefreshCw,
  Megaphone,
  RotateCcw,
  Search,
  Send,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  SlidersHorizontal,
  Smartphone,
  Tag,
  TrendingUp,
  Bold,
  Italic,
  List,
  ListOrdered,
  Heading2,
  SquarePlus,
  Star,
  Sun,
  Moon,
  Tablet,
  Ticket,
  Trash2,
  Unplug,
  Upload,
  User,
  UserPlus,
  UserRound,
  Users,
  UsersRound,
  Video,
  X,
  type LucideIcon,
  Sparkles,
  SquarePen,
  History,
  ThumbsUp,
  ThumbsDown,
  MousePointerClick,
  Undo2,
  CircleStop,
  SendHorizontal,
  MessageSquare,
  Navigation,
  ScanEye,
  Wallet,
  Zap,
  ExternalLink,
} from 'lucide-react';

export const ICON_REGISTRY = {
  Bold: Bold,
  Italic: Italic,
  List: List,
  ListOrdered: ListOrdered,
  Heading2: Heading2,
  Activity: Activity,
  AlertCircle: CircleAlert,
  AlertTriangle: AlertTriangle,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  BarChart: BarChart3,
  Bell: Bell,
  Book: Book,
  BookOpen: BookOpen,
  Box: Box,
  Building: Building2,
  Globe: Globe,
  MapPin: MapPin,
  Calendar: Calendar,
  Check: Check,
  CheckCircle: CircleCheck,
  ChevronDown: ChevronDown,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  Clipboard: Clipboard,
  Copy: Copy,
  ClipboardCheck: ClipboardCheck,
  ClipboardList: ClipboardList,
  Mic: Mic,
  MicOff: MicOff,
  PhoneOff: PhoneOff,
  Clock: Clock,
  Crown: Crown,
  Download: Download,
  Edit: Pencil,
  Eye: Eye,
  EyeOff: EyeOff,
  FilePlus: FilePlus,
  FileSpreadsheet: FileSpreadsheet,
  FileText: FileText,
  Filter: Filter,
  Folder: Folder,
  Grid: LayoutGrid,
  Hash: Hash,
  Heart: Heart,
  Home: House,
  Image: Image,
  Info: Info,
  KeyRound: KeyRound,
  LayoutDashboard: LayoutDashboard,
  Link: Link,
  LineChart: LineChart,
  Lock: Lock,
  LogIn: LogIn,
  LogOut: LogOut,
  Mail: Mail,
  MailCheck: MailCheck,
  MessageCircle: MessageCircle,
  Monitor: Monitor,
  MoreHorizontal: MoreHorizontal,
  Paperclip: Paperclip,
  Palette: Palette,
  PawPrint: PawPrint,
  PieChart: PieChart,
  Phone: Phone,
  Play: Play,
  Plus: Plus,
  PlusSquare: SquarePlus,
  Printer: Printer,
  RefreshCw: RefreshCw,
  Undo: RotateCcw,
  Megaphone: Megaphone,
  Search: Search,
  Send: Send,
  Settings: Settings,
  Shield: Shield,
  ShieldAlert: ShieldAlert,
  ShieldCheck: ShieldCheck,
  Sliders: SlidersHorizontal,
  Smartphone: Smartphone,
  Star: Star,
  Tag: Tag,
  TrendingUp: TrendingUp,
  Sun: Sun,
  Moon: Moon,
  Tablet: Tablet,
  Ticket: Ticket,
  Trash: Trash2,
  Unplug: Unplug,
  Upload: Upload,
  User: User,
  UserPlus: UserPlus,
  UserRound: UserRound,
  Users: Users,
  UsersRound: UsersRound,
  Video: Video,
  Sparkles: Sparkles,
  SquarePen: SquarePen,
  History: History,
  ThumbsUp: ThumbsUp,
  ThumbsDown: ThumbsDown,
  MousePointerClick: MousePointerClick,
  Undo2: Undo2,
  CircleStop: CircleStop,
  SendHorizontal: SendHorizontal,
  MessageSquare: MessageSquare,
  Navigation: Navigation,
  ScanEye: ScanEye,
  Wallet: Wallet,
  Zap: Zap,
  ExternalLink: ExternalLink,
  X: X,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICON_REGISTRY;
